<template>
    <div>
        <Pane title="重新提交设计计划" :showRemarks="false">
            <template>重新发起设计计划流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 20 }">
                <a-form :model="form" layout="horizontal" :colon="false" label-align="right"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }">
                    <div class="header-right">
                        <div class="header-right-item">
                            <div style="display: inline-block;width: 100px;">版本号：</div>
                            <a-select v-model="form.version" placeholder="请选择" disabled>
                                <a-select-option v-for="v in versionList" :key="v.value" :value="v.value">{{
                                        v.label
                                    }}
                                </a-select-option>
                            </a-select>
                        </div>
                        <div>表单状态：{{ approveStatusName }}</div>
                    </div>

                    <div class="title" style="margin-top: 0">基本信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="项目名称">
                                    <a-input v-model="form.projectName" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目编码">
                                    <a-input v-model="form.projectCode" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计编码">
                                    <a-input v-model="form.designCode" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目阶段">
                                    <a-input :value="phaseDisplayName" placeholder="请选择项目阶段" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="管理级别">
                                    <a-radio-group v-model="form.manageLevel" placeholder="请选择管理级别" disabled>
                                        <a-radio-button
                                            v-for="item in manageLevelList"
                                            :key="item.value"
                                            :value="item.value"
                                        >{{ item.name }}
                                        </a-radio-button>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="要求完成时间">
                                    <a-date-picker v-model="form.requireFinishDate" style="width: 100%"/>
                                </a-form-item>
                            </a-col>

                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="参与专业" required>
                                    <a-checkbox-group v-model="form.majorsArray">
                                        <a-checkbox
                                            v-for="item in majorList"
                                            :key="item.value"
                                            :value="item.value"
                                        >{{ item.name }}
                                        </a-checkbox>
                                    </a-checkbox-group>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="title" style="margin-top: 10px">项目成员</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="项目负责人" required>
                                    <EmployeeSelector
                                        @change="handlePrjLeaderChange"
                                        :value="getPrjLeaderValue()"
                                        mode="multiple" :single="false"
                                    >
                                        <a-button block style="text-align: left;width: 250px;">{{
                                                form.prjLeaderName || "请选择项目负责人"
                                            }}
                                        </a-button>
                                    </EmployeeSelector>
                                </a-form-item>
                            </a-col>
                            <!--              <a-col :span="12">-->
                            <!--                <a-form-item label="项目负责人部门" required>-->
                            <!--                  <a-select-->
                            <!--                      show-search-->
                            <!--                      :filter-option="$selectFilterOption"-->
                            <!--                      v-model="form.mainDeptId"-->
                            <!--                      placeholder="请选择项目负责人部门"-->
                            <!--                      style="width: 100%"-->
                            <!--                      @change="handleMainDeptChange"-->
                            <!--                  >-->
                            <!--                    <a-select-option-->
                            <!--                        v-for="item in organizationList"-->
                            <!--                        :key="item.id"-->
                            <!--                        :value="item.id"-->
                            <!--                    >{{ item.uniqueName }}-->
                            <!--                    </a-select-option>-->
                            <!--                  </a-select>-->
                            <!--                </a-form-item>-->
                            <!--              </a-col>-->
                            <a-col :span="12">
                                <a-form-item label="项目分管总工" required>
                                    <a-select
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        label-in-value
                                        :value="selectedDeptChiefEngineer"
                                        placeholder="请选择项目分管总工"
                                        @change="(val) => handlePersonnelSelect(val, 'chiefEngineer')"
                                        style="width: 100%"
                                    >
                                        <a-select-option v-for="item in (form.manageLevel === 'company' ? companyChiefEngineers : deptChiefEngineers)" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="部门分管负责人" required>
                                    <a-select
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        label-in-value
                                        :value="selectedMaster"
                                        placeholder="请选择部门分管负责人"
                                        @change="(val) => handlePersonnelSelect(val, 'deptLeader')"
                                        style="width: 100%"
                                    >
                                        <a-select-option v-for="item in masters" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="总工" required>
                                    <a-select
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        label-in-value
                                        :value="selectedGeneralEngineer"
                                        placeholder="请选择总工"
                                        @change="(val) => handlePersonnelSelect(val, 'generalEngineer')"
                                        style="width: 100%"
                                    >
                                        <a-select-option v-for="item in generalEngineers" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="批准人" required>
                                    <EmployeeSelector
                                        @change="handleEmployeeChange($event, 'approverName', 'approverId')"
                                        :value="getEmployeeValue('approverName', 'approverId')"
                                    >
                                        <a-button block style="text-align: left;width: 250px;">{{ form.approverName || "请选择批准人" }}</a-button>
                                    </EmployeeSelector>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="公司分管领导" :required="isCompanyManageLevel">
                                    <a-select
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        label-in-value
                                        :value="selectedCompanyChiefEngineer"
                                        placeholder="请选择公司分管领导"
                                        :disabled="form.manageLevel === 'dept'"
                                        @change="(val) => handlePersonnelSelect(val, 'companyLeader')"
                                        style="width: 100%"
                                    >
                                        <a-select-option v-for="item in chargeLeaders" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="配合部门">
                                    <a-select
                                        mode="multiple"
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        v-model="form.cooperateDeptIds"
                                        placeholder="请选择配合部门"
                                        style="width: 100%"
                                        @change="handleCooperateDeptChange"
                                    >
                                        <a-select-option
                                            v-for="item in organizationList"
                                            :key="item.id"
                                            :value="item.id"
                                        >{{ item.uniqueName }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目类别">
                                    <a-radio-group v-model="form.prjCategory" placeholder="请选择">
                                        <a-radio-button disabled v-for="item in prjCategoryList" :key="item.value" :value="item.value">
                                            {{ item.name }}
                                        </a-radio-button>
                                    </a-radio-group>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <a-col :lg="24" :md="24" :sm="24">
                        <div class="specVicePresident">
                            <div class="hint">
                                <span class="hintTitle">总工</span><span class="hintName">-院管项目填公司总工，所管项目填部门总工；</span>
                                <span class="hintTitle">项目分管总工</span><span class="hintName">-院管项目填公司专业副总，所管项目填部门副总工或总工，分管总工为主专业审定人。</span>
                            </div>
                            <div class="hint">
                                <span class="hintTitle">公司分管领导</span><span class="hintName">-院管项目填写项目所属区域负责人；</span>
                                <span class="hintTitle">配合部门</span><span class="hintName">-项目组成员中有其他部门人员，需该部门负责人会签。</span>
                            </div>
                            <div class="hint">
                                <span class="hintName">公司管项目（总院）所有专业需签到审定</span>
                            </div>
                        </div>
                    </a-col>

                    <div class="title" style="margin-top: 10px">专业人员信息</div>
                    <div class="wrapper">
                        <div class="table-wrapper">
                            <a-table
                                style="background: #fff;"
                                :columns="majorsColumns"
                                :data-source="form.majorsDetail || []"
                                row-key="majorValue"
                                :pagination="false"
                                bordered
                            >
                                <template slot="majorLeader" slot-scope="text, record">
                                    <EmployeeSelector
                                        @change="(arr) => handleMajorEmployeeChange(arr, record, 'majorLeaderNames', 'majorLeaderIds')"
                                        :value="getMajorEmployeeValue(record, 'majorLeaderNames', 'majorLeaderIds')"
                                        :single="false"
                                    >
                                        <a-input size="small" style="text-align: left;" :value="record.majorLeaderNames || '请选择'"></a-input>
                                    </EmployeeSelector>
                                </template>
                                <template slot="designer" slot-scope="text, record">
                                    <EmployeeSelector
                                        @change="(arr) => handleMajorEmployeeChange(arr, record, 'designerNames', 'designerIds')"
                                        :value="getMajorEmployeeValue(record, 'designerNames', 'designerIds')"
                                        :single="false"
                                    >
                                        <a-input size="small" style="text-align: left;" :value="record.designerNames || '请选择'"></a-input>
                                    </EmployeeSelector>
                                </template>
                                <template slot="reviewer" slot-scope="text, record">
                                    <EmployeeSelector
                                        @change="(arr) => handleMajorEmployeeChange(arr, record, 'reviewerNames', 'reviewerIds')"
                                        :value="getMajorEmployeeValue(record, 'reviewerNames', 'reviewerIds')"
                                        :single="false"
                                    >
                                        <a-input size="small" style="text-align: left;" :value="record.reviewerNames || '请选择'"></a-input>
                                    </EmployeeSelector>
                                </template>
                                <template slot="auditor" slot-scope="text, record">
                                    <EmployeeSelector
                                        @change="(arr) => handleMajorEmployeeChange(arr, record, 'auditorNames', 'auditorIds')"
                                        :value="getMajorEmployeeValue(record, 'auditorNames', 'auditorIds')"
                                        :single="false"
                                    >
                                        <a-input size="small" style="text-align: left;" :value="record.auditorNames || '请选择'"></a-input>
                                    </EmployeeSelector>
                                </template>
                                <template slot="approver" slot-scope="text, record">
                                    <EmployeeSelector
                                        @change="(arr) => handleMajorEmployeeChange(arr, record, 'approverNames', 'approverIds')"
                                        :value="getMajorEmployeeValue(record, 'approverNames', 'approverIds')"
                                        :single="false"
                                    >
                                        <a-input size="small" style="text-align: left;" :value="record.approverNames || '请选择'"></a-input>
                                    </EmployeeSelector>
                                </template>
                                <template slot="remark" slot-scope="text, record">
                                    <a-input v-model="record.remark" size="small"/>
                                </template>
                            </a-table>
                        </div>
                    </div>

                    <div class="title" style="margin-top: 10px">子项信息</div>
                    <div class="wrapper">
                        <a-row>
                            <a-col :lg="24" :md="24" :sm="24">
                                <div class="hintInit">
                                    <span class="hintName">提示：第一次策划不确定但后期需增加子项时，也必须选择拆分子项，保证至少一个子项。</span>
                                </div>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <div class="hintInit">
                                    是否拆分子项 <a-switch v-model="form.hasSubItem" @change="onHasSubItemChange" />
                                </div>
                            </a-col>
                            <template v-if="form.hasSubItem">
                                <a-col :lg="24" :md="24" :sm="24">
                                    <div style="max-width: 90%; margin: 0 0 8px 5%; display: flex; gap: 8px;">
                                        <a-button type="primary" icon="plus" @click="addSubItem">新增</a-button>
                                        <a-button type="danger" icon="minus" @click="removeSubItem">移除</a-button>
                                    </div>
                                </a-col>
                                <a-col :lg="24" :md="24" :sm="24">
                                    <a-table
                                        style="max-width: 90%;margin: 0 auto;background: #fff;"
                                        :columns="subItemsColumns"
                                        :data-source="form.subItems || []"
                                        row-key="_rowKey"
                                        :pagination="false"
                                        :row-selection="{ selectedRowKeys: selectedSubItemKeys, onChange: onSubItemSelectChange }"
                                        bordered
                                    >
                                        <template slot="subCode" slot-scope="text, record">
                                            <a-input v-model="record.subCode"/>
                                        </template>
                                        <template slot="subName" slot-scope="text, record">
                                            <a-input v-model="record.subName"/>
                                        </template>
                                        <template slot="subLeaderName" slot-scope="text, record">
                                            <EmployeeSelector
                                                @change="(arr) => handleSubItemLeaderChange(arr, record)"
                                                :value="getSubItemLeaderValue(record)"
                                                :single="false"
                                            >
                                                <a-input size="small" style="text-align: left;height: 30px;" :value="record.subLeaderName || '请选择'"></a-input>
                                            </EmployeeSelector>
                                        </template>
                                        <template slot="majors" slot-scope="text, record">
                                            <a-select v-model="record.majors" mode="multiple" style="width: 100%" placeholder="请选择参与专业">
                                                <a-select-option v-for="item in majorList" :key="item.value" :value="item.value">{{
                                                        item.name
                                                    }}
                                                </a-select-option>
                                            </a-select>
                                        </template>
                                        <template slot="remark" slot-scope="text, record">
                                            <a-input v-model="record.remark"/>
                                        </template>
                                    </a-table>
                                </a-col>
                            </template>
                        </a-row>
                    </div>

                    <div class="title" style="margin-top: 10px">子项专业人员信息</div>
                    <div class="wrapper">
                        <a-table
                            style="max-width: 90%;margin: 0 auto;background: #fff;"
                            :columns="subMajorsColumns"
                            :data-source="form.subMajors || []"
                            row-key="_rowKey"
                            :pagination="false"
                            bordered
                        >
                            <template slot="subMajorLeader" slot-scope="text, record">
                                <EmployeeSelector
                                    @change="(arr) => handleSubMajorEmployeeChange(arr, record, 'majorLeaderNames', 'majorLeaderIds')"
                                    :value="getMajorEmployeeValue(record, 'majorLeaderNames', 'majorLeaderIds')"
                                    :single="false"
                                >
                                    <a-input size="small" style="text-align: left;" :value="record.majorLeaderNames || '请选择'"></a-input>
                                </EmployeeSelector>
                            </template>
                            <template slot="subDesigner" slot-scope="text, record">
                                <a-select
                                    mode="multiple"
                                    :options="getSubMajorOptions(record, 'designer')"
                                    :value="getSubMajorSelectedIds(record, 'designer')"
                                    @change="(vals) => handleSubMajorSelectChange(vals, record, 'designer')"
                                    style="width: 100%"
                                    placeholder="请选择设计人"
                                    size="small"
                                />
                            </template>
                            <template slot="subReviewer" slot-scope="text, record">
                                <a-select
                                    mode="multiple"
                                    :options="getSubMajorOptions(record, 'reviewer')"
                                    :value="getSubMajorSelectedIds(record, 'reviewer')"
                                    @change="(vals) => handleSubMajorSelectChange(vals, record, 'reviewer')"
                                    style="width: 100%"
                                    placeholder="请选择复核人"
                                    size="small"
                                />
                            </template>
                            <template slot="subAuditor" slot-scope="text, record">
                                <a-select
                                    mode="multiple"
                                    :options="getSubMajorOptions(record, 'auditor')"
                                    :value="getSubMajorSelectedIds(record, 'auditor')"
                                    @change="(vals) => handleSubMajorSelectChange(vals, record, 'auditor')"
                                    style="width: 100%"
                                    placeholder="请选择审核人"
                                    size="small"
                                />
                            </template>
                            <template slot="subApprover" slot-scope="text, record">
                                <a-select
                                    mode="multiple"
                                    :options="getSubMajorOptions(record, 'approver')"
                                    :value="getSubMajorSelectedIds(record, 'approver')"
                                    @change="(vals) => handleSubMajorSelectChange(vals, record, 'approver')"
                                    style="width: 100%"
                                    placeholder="请选择审定人"
                                    size="small"
                                />
                            </template>
                            <template slot="subRemark" slot-scope="text, record">
                                <a-input v-model="record.remark" size="small"/>
                            </template>
                        </a-table>
                    </div>

                    <div class="title" style="margin-top: 10px">详细信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="设计评审方式">
                                    <a-input value="会议式" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计评审时间" required>
                                    <a-date-picker v-model="form.designReviewDate" style="width: 100%"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计输入下达时间" required>
                                    <a-date-picker v-model="form.designInputDate" style="width: 100%"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="出图时间" required>
                                    <a-date-picker v-model="form.drawingDate" style="width: 100%"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="归档时间" required>
                                    <a-date-picker v-model="form.archiveDate" style="width: 100%"/>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <div class="specVicePresident">
                                    <div class="hint">
                                        <span class="hintName">时间先后顺序：设计输入下达-设计评审-出图-归档</span>
                                    </div>
                                </div>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="专业提资时间" required>
                                    <a-textarea v-model="form.majorSubmitDate" :rows="3"/>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="所需特殊装备及设施" required>
                                    <a-textarea v-model="form.specialEquipment" :rows="3"/>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="要达到的质量目标及要求" required>
                                    <a-textarea v-model="form.qualityTarget" :rows="3"/>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <div class="specVicePresident">
                                    <div class="hint">
                                        <span class="hintTitle">其他：1、互提资料贯穿于设计全过程，按设计进度适时开展；2、设计验证活动贯穿于设计全过程，按设计进度适时开展；</span>
                                    </div>
                                </div>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="备注">
                                    <a-textarea v-model="form.remark" :rows="3"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="上传">
                                    <FileUpload @uploaded="uploaded">
                                        <a-button type="primary">立即上传</a-button>
                                    </FileUpload>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item label="附件" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" required>
                                    <a-table bordered :dataSource="fileList" :pagination="false" :rowKey="(record, index) => index">
                                        <a-table-column title="名称">
                                            <template slot-scope="text">
                                                <template v-if="text.completePath">
                                                    <a :href="text.completePath" target="_blank" @click.prevent="handleFileClick($event, text.completePath, decodeURIComponent($getFileName(text.completePath)))">{{ decodeURIComponent($getFileName(text.completePath)) }}</a>
                                                </template>
                                                <template v-else>{{ text.name }}</template>
                                            </template>
                                        </a-table-column>
                                        <a-table-column title="操作" align="center">
                                            <template slot-scope="text, record, index">
                                                <a href="#" @click.prevent="deleteFile(index)" class="danger">删除</a>
                                            </template>
                                        </a-table-column>
                                    </a-table>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import { fetchDesignPlanDetail, resubmitDesignPlan } from "@/api/project-plan/plan";
import { getPersonnel, getCompanyPersonnel } from "@/api/project-approval/review";
import { mapMutations, mapGetters, mapState } from "vuex";
import moment from "moment";
import EmployeeSelector from "@/components/employee-selector";
import FileUpload from "@/components/file-oss-upload";
import organization from "@/mixins/organization";
import { parseAttachment, buildAttachmentData } from '@/utils/attachment'

export default {
    name: "DesignPlanReapply",
    mixins: [organization],
    components: {
        EmployeeSelector,
        FileUpload
    },
    data() {
        return {
            loading: false,
            submitting: false,
            id: "",
            taskId: "",
            instanceId: "",
            fileList: [],
            selectedSubItemKeys: [],
            masters: [],
            deptChiefEngineers: [],
            chargeLeaders: [],
            companyChiefEngineers: [],
            generalEngineers: [],
            selectedMaster: undefined,
            selectedDeptChiefEngineer: undefined,
            selectedCompanyChiefEngineer: undefined,
            selectedGeneralEngineer: undefined,
            form: {
                projectName: "",
                code: "",
                designCode: "",
                phaseCode: "",
                manageLevel: "",
                requireFinishDate: null,
                majorsArray: [],
                majorsDetail: [],
                prjLeaderName: "",
                prjLeaderId: "",
                chiefEngineerName: "",
                chiefEngineerId: "",
                deptLeaderName: "",
                deptLeaderId: "",
                generalEngineerName: "",
                generalEngineerId: "",
                approverName: "",
                approverId: "",
                companyLeaderName: "",
                companyLeaderId: "",
                cooperateDeptIds: [],
                cooperateDeptNames: [],
                prjCategory: "",
                hasSubItem: false,
                subItems: [],
                subMajors: [],
                designReviewDate: null,
                designInputDate: null,
                drawingDate: null,
                archiveDate: null,
                majorSubmitDate: "",
                specialEquipment: "",
                qualityTarget: "",
                remark: "",
                attachment: "",
                version: "1",
                projectCode: "",
                mainDeptName: "",
                mainDeptId: "",
                prjLeaderDeptName: "",
                prjLeaderDeptId: "",
                approveStatus: "",
            },
            majorsColumns: [
                {title: '专业名称', dataIndex: 'majorName', width: 80},
                {title: '专业编号', dataIndex: 'majorCode', width: 80},
                {title: '专业负责人', dataIndex: 'majorLeaderNames', width: 150, scopedSlots: {customRender: 'majorLeader'}},
                {title: '设计人', dataIndex: 'designerNames', width: 150, scopedSlots: {customRender: 'designer'}},
                {title: '复核人', dataIndex: 'reviewerNames', width: 150, scopedSlots: {customRender: 'reviewer'}},
                {title: '审核人', dataIndex: 'auditorNames', width: 120, scopedSlots: {customRender: 'auditor'}},
                {title: '* 审定人', dataIndex: 'approverNames', width: 120, scopedSlots: {customRender: 'approver'}},
                {title: '备注', dataIndex: 'remark', width: 120, scopedSlots: {customRender: 'remark'}},
            ],
            subItemsColumns: [
                {title: '* 子项编号', dataIndex: 'subCode', width: 80, scopedSlots: {customRender: 'subCode'}},
                {title: '* 子项名称', dataIndex: 'subName', width: 80, scopedSlots: {customRender: 'subName'}},
                {title: '* 参与专业', dataIndex: 'majors', width: 200, scopedSlots: {customRender: 'majors'}},
                {title: '* 子项负责人', dataIndex: 'subLeaderName', width: 150, scopedSlots: {customRender: 'subLeaderName'}},
                {title: '计划结束日期', dataIndex: 'planEndDate', width: 120},
                {title: '排序', dataIndex: 'sortNo', width: 50},
                {title: '备注', dataIndex: 'remark', width: 150, scopedSlots: {customRender: 'remark'}},
            ],
            subMajorsColumns: [
                {title: '子项名称', dataIndex: 'subName', width: 70},
                {title: '子项编号', dataIndex: 'subCode', width: 70},
                {title: '专业名称', dataIndex: 'majorName', width: 70},
                {title: '专业编号', dataIndex: 'majorCode', width: 70},
                {title: '设计人', dataIndex: 'designerNames', width: 150, scopedSlots: {customRender: 'subDesigner'}},
                {title: '复核人', dataIndex: 'reviewerNames', width: 150, scopedSlots: {customRender: 'subReviewer'}},
                {title: '审核人', dataIndex: 'auditorNames', width: 120, scopedSlots: {customRender: 'subAuditor'}},
                {title: '审定人', dataIndex: 'approverNames', width: 120, scopedSlots: {customRender: 'subApprover'}},
            ],
        };
    },
    computed: {
        ...mapState("approval", ["detail"]),
        ...mapGetters("setting", ["findDataDict"]),
        manageLevelList() {
            return this.findDataDict("cosys.manageLevel") || [];
        },
        prjCategoryList() {
            const list = this.findDataDict("cosys.prjCategory") || [];
            if (this.form && !this.form.prjCategory) {
                const defaultCategory = list.find(item => item.name === '一般项目');
                if (defaultCategory) {
                    this.$set(this.form, 'prjCategory', defaultCategory.value);
                }
            }
            return list;
        },
        majorList() {
            return this.findDataDict("cosys.major") || [];
        },
        designPhaseList() {
            return this.findDataDict("cosys.designPhase") || [];
        },
        phaseDisplayName() {
            const code = this.form.phaseCode;
            if (code === null || code === undefined || code === '') return '';
            const norm = v => String(v == null ? '' : v).trim().toLowerCase();
            const target = norm(code);
            const list = this.designPhaseList || [];
            let item = list.find(d => norm(d.value) === target);
            if (!item) {
                item = list.find(d => norm(d.name) === target);
            }
            return item ? item.name : (this.form.phaseName || String(code));
        },
        isCompanyManageLevel() {
            return this.form && this.form.manageLevel === 'company';
        },
        versionList() {
            return [{ value: '1', label: 'V1.0' }];
        },
        approveStatusName() {
            const list = this.findDataDict("cosys.approveStatus") || [];
            const item = list.find(d => d.value === this.form.approveStatus);
            return item ? item.name : '未启动';
        },
    },
    watch: {
        'form.majorsArray': {
            immediate: true,
            handler(newMajors) {
                if (!this.form.majorsDetail) {
                    this.$set(this.form, 'majorsDetail', []);
                }
                const detail = this.form.majorsDetail;
                const majorMap = {};
                detail.forEach(item => {
                    majorMap[item.majorValue] = item;
                });
                const newDetail = [];
                (newMajors || []).forEach(majorValue => {
                    const majorItem = this.majorList.find(m => m.value === majorValue);
                    if (majorItem) {
                        if (majorMap[majorValue]) {
                            newDetail.push(majorMap[majorValue]);
                        } else {
                            newDetail.push({
                                majorValue: majorValue,
                                majorName: majorItem.name,
                                majorCode: majorItem.value || '',
                                majorLeaderNames: '',
                                majorLeaderIds: '',
                                designerNames: '',
                                designerIds: '',
                                reviewerNames: '',
                                reviewerIds: '',
                                auditorNames: '',
                                auditorIds: '',
                                approverNames: '',
                                approverIds: '',
                                remark: ''
                            });
                        }
                    }
                });
                this.$set(this.form, 'majorsDetail', newDetail);
            }
        },
        'form.subItems': {
            deep: true,
            handler() {
                this.updateSubMajorsFromSubItems();
            }
        },
        'form.majorsDetail': {
            deep: true,
            handler() {
                this.syncSubMajorsFromMajorsDetail();
            }
        },
        'form.prjLeaderDeptId': {
            immediate: true,
            handler(val) {
                if (val) this.fetchPersonnel(val);
            }
        },
        'form.manageLevel': {
            handler() {
                if (this.form.prjLeaderDeptId) {
                    this.fetchPersonnel(this.form.prjLeaderDeptId);
                }
            }
        },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.id) {
            this.fetchDetail(this.id);
        }
        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),

        fetchDetail(id) {
            this.loading = true;
            fetchDesignPlanDetail(id)
                .then((res) => {
                    const data = res || {};
                    this.populateForm(data);
                    this.loading = false;
                })
                .catch(() => {
                    this.$message.error("获取设计计划详情失败");
                    this.loading = false;
                });
        },

        populateForm(data) {
            this.$set(this.form, 'subItems', []);
            this.$set(this.form, 'subMajors', []);
            this.$set(this.form, 'majorsDetail', []);
            this.$set(this.form, 'majorsArray', []);
            this.$set(this.form, 'hasSubItem', false);

            const dateFields = ['requireFinishDate', 'archiveDate', 'designInputDate', 'designReviewDate', 'drawingDate'];

            Object.keys(data).forEach(key => {
                if (data[key] === null || data[key] === undefined) return;
                const skipKeys = ['majors', 'majorsDetail', 'subItems', 'subMajors', 'majorsArray', 'hasSubItem'];
                if (skipKeys.includes(key)) return;
                if (dateFields.includes(key) && data[key]) {
                    this.$set(this.form, key, moment(data[key]));
                } else {
                    this.$set(this.form, key, data[key]);
                }
            });

            // 配合部门字段兼容：后端可能返回单数字段 cooperateDeptId/cooperateDeptName 或复数数组
            const deptId = this.form.cooperateDeptIds || this.form.cooperateDeptId;
            if (typeof deptId === 'string' && deptId) {
                this.$set(this.form, 'cooperateDeptIds', deptId.split(',').filter(Boolean));
            }
            const deptName = this.form.cooperateDeptNames || this.form.cooperateDeptName;
            if (typeof deptName === 'string' && deptName) {
                this.$set(this.form, 'cooperateDeptNames', deptName.split(',').filter(Boolean));
            }

            const majorsDetail = (data.majorsDetail || []).map(item => ({
                ...item,
                majorValue: item.majorCode || item.majorValue || ''
            }));
            this.$set(this.form, 'majorsDetail', majorsDetail);

            this.$set(this.form, 'majorsArray', this.normalizeMajorValue(data.majors));

            const subItems = (data.subItems || []).map((item, index) => ({
                ...item,
                _rowKey: item.id || `sub_${index}`,
                majors: this.normalizeMajorValue(item.majors)
            }));
            this.$set(this.form, 'subItems', subItems);

            // subMajors 行必须关联到所属 subItem，否则提交时按 _rowKey 前缀分组会全部丢失。
            // 优先按行自身携带的子项编号/名称（真实归属）匹配，旧数据无 subCode 时
            // 再按"参与专业包含该专业"兜底（同一专业出现在多个子项时避免全部并入第一个）
            this.$set(this.form, 'subMajors', (data.subMajors || []).map((item, index) => {
                const majorValue = item.majorValue || item.majorCode || '';
                let parent = null;
                if (item.subCode && item.subName) {
                    parent = subItems.find(si => si.subCode === item.subCode && si.subName === item.subName);
                }
                if (!parent && item.subCode) {
                    parent = subItems.find(si => si.subCode === item.subCode);
                }
                if (!parent) {
                    parent = subItems.find(si => {
                        const majors = Array.isArray(si.majors) ? si.majors : [];
                        return majors.includes(majorValue);
                    });
                }
                return {
                    ...item,
                    _rowKey: parent ? `${parent._rowKey}_${majorValue}` : `unlinked_${index}`,
                    majorValue
                };
            }));

            this.$set(this.form, 'version', data.planVersion || data.version || '1');
            this.$set(this.form, 'hasSubItem', data.subItems && data.subItems.length > 0);

            this.fileList = parseAttachment(data.attachment, data.attachmentPaths)

            this.$nextTick(() => this.syncSelectedPersonnel());
        },

        normalizeMajorValue(value) {
            if (Array.isArray(value)) return value;
            if (!value) return [];
            return String(value).split(',').filter(Boolean);
        },

        uploaded(list) {
            this.fileList = [...this.fileList, ...list];
        },

        deleteFile(index) {
            this.fileList.splice(index, 1);
        },

        formatDate(value) {
            if (!value) return '';
            if (moment.isMoment(value)) return value.format('YYYY-MM-DD HH:mm:ss');
            return moment(value).format('YYYY-MM-DD HH:mm:ss');
        },

        normalizeMajors(value) {
            return Array.isArray(value) ? value.join(',') : (value || '');
        },

        buildSubmitParams() {
            const dateFields = ['archiveDate', 'designInputDate', 'designReviewDate', 'drawingDate', 'requireFinishDate'];
            const params = {
                id: this.id,
                ...this.form,
                cooperateDeptIds: (this.form.cooperateDeptIds || []).join(','),
                cooperateDeptNames: (this.form.cooperateDeptNames || []).join(','),
                ...buildAttachmentData(this.fileList),
                majors: this.normalizeMajors(this.form.majorsArray),
                majorsDetail: (this.form.majorsDetail || []).map((item, i) => ({
                    ...item,
                    sortNo: i + 1,
                })),
                prjLeaderDeptId: this.form.prjLeaderDeptId,
                prjLeaderDeptName: this.form.prjLeaderDeptName,
                subItems: (this.form.subItems || []).map(item => ({
                    ...item,
                    majors: this.normalizeMajors(item.majors),
                    planEndDate: this.formatDate(item.planEndDate) || '-',
                    subMajors: (this.form.subMajors || [])
                        .filter(sm => sm._rowKey === item._rowKey || String(sm._rowKey).startsWith(String(item._rowKey) + '_'))
                        .map((sm, i) => ({
                            ...sm,
                            sortNo: i + 1
                        }))
                }))
            };

            dateFields.forEach(field => {
                params[field] = this.formatDate(params[field]);
            });
            delete params.majorsArray;
            delete params.subMajors;
            delete params.version;
            delete params.code;
            return params;
        },

        handlePrjLeaderChange(arr) {
            if (arr.length) {
                this.$set(this.form, 'prjLeaderName', arr.map(item => item.name).join(','));
                this.$set(this.form, 'prjLeaderId', arr.map(item => item.userId).join(','));
            } else {
                this.$set(this.form, 'prjLeaderName', '');
                this.$set(this.form, 'prjLeaderId', '');
            }
        },

        getPrjLeaderValue() {
            const names = (this.form.prjLeaderName || '').split(',').filter(Boolean);
            const ids = (this.form.prjLeaderId || '').split(',').filter(Boolean);
            return names.map((name, idx) => ({name, userId: ids[idx] || ''}));
        },

        handleEmployeeChange(arr, nameField, idField) {
            if (arr.length) {
                this.$set(this.form, nameField, arr[0].name);
                this.$set(this.form, idField, arr[0].userId);
            } else {
                this.$set(this.form, nameField, '');
                this.$set(this.form, idField, '');
            }
        },

        getEmployeeValue(nameField, idField) {
            const name = this.form[nameField];
            const userId = this.form[idField];
            return name ? [{name, userId}] : [];
        },

        async fetchPersonnel(orgId) {
            if (!orgId) return;
            try {
                const isCompany = this.form && this.form.manageLevel === 'company';
                const normalize = items => (items || []).map(item => ({ ...item, userId: item.userId || item.id }));
                if (isCompany) {
                    const [companyRes, personnelRes] = await Promise.all([
                        getCompanyPersonnel(orgId),
                        getPersonnel(orgId)
                    ]);
                    this.masters = normalize(personnelRes.masters);
                    this.deptChiefEngineers = normalize(companyRes.deptChiefEngineers);
                    this.chargeLeaders = normalize(personnelRes.chargeLeaders);
                    this.companyChiefEngineers = normalize(companyRes.companyChiefEngineers);
                    if (companyRes.masterEngineer) {
                        this.generalEngineers = normalize([{ id: companyRes.masterEngineer, name: companyRes.masterEngineerName }]);
                    }
                } else {
                    const res = await getPersonnel(orgId);
                    this.masters = normalize(res.masters);
                    this.deptChiefEngineers = normalize(res.deptChiefEngineers);
                    this.chargeLeaders = normalize(res.chargeLeaders);
                    this.companyChiefEngineers = normalize(res.companyChiefEngineers);
                    if (res.masterEngineer) {
                        this.generalEngineers = normalize([{ id: res.masterEngineer, name: res.masterEngineerName }]);
                    } else {
                        this.generalEngineers = normalize(res.companyChiefEngineers);
                    }
                }
                this.$nextTick(() => this.syncSelectedPersonnel());
            } catch (e) {
                console.error('获取人员列表失败', e);
            }
        },

        handlePersonnelSelect(val, type) {
            const nameMap = { deptLeader: 'deptLeaderName', companyLeader: 'companyLeaderName', chiefEngineer: 'chiefEngineerName', generalEngineer: 'generalEngineerName' };
            const idMap = { deptLeader: 'deptLeaderId', companyLeader: 'companyLeaderId', chiefEngineer: 'chiefEngineerId', generalEngineer: 'generalEngineerId' };
            const selectMap = { deptLeader: 'selectedMaster', companyLeader: 'selectedCompanyChiefEngineer', chiefEngineer: 'selectedDeptChiefEngineer', generalEngineer: 'selectedGeneralEngineer' };
            if (val && val.key) {
                this[selectMap[type]] = val;
                this.$set(this.form, nameMap[type], val.label);
                this.$set(this.form, idMap[type], val.key);
            } else {
                this[selectMap[type]] = undefined;
                this.$set(this.form, nameMap[type], '');
                this.$set(this.form, idMap[type], '');
            }
        },

        syncSelectedPersonnel() {
            this.selectedMaster = this.form.deptLeaderId && this.form.deptLeaderName
                ? { key: this.form.deptLeaderId, label: this.form.deptLeaderName } : undefined;
            this.selectedDeptChiefEngineer = this.form.chiefEngineerId && this.form.chiefEngineerName
                ? { key: this.form.chiefEngineerId, label: this.form.chiefEngineerName } : undefined;
            this.selectedCompanyChiefEngineer = this.form.companyLeaderId && this.form.companyLeaderName
                ? { key: this.form.companyLeaderId, label: this.form.companyLeaderName } : undefined;
            this.selectedGeneralEngineer = this.form.generalEngineerId && this.form.generalEngineerName
                ? { key: this.form.generalEngineerId, label: this.form.generalEngineerName } : undefined;
        },

        handleCooperateDeptChange(values) {
            this.$set(this.form, 'cooperateDeptIds', values);
            this.$set(this.form, 'cooperateDeptNames', (values || []).map(v => {
                const selected = this.organizationList.find(item => item.id === v);
                return selected ? selected.uniqueName : '';
            }));
        },

        handleMainDeptChange(value) {
            const selected = this.organizationList.find(item => item.id === value);
            this.$set(this.form, 'mainDeptName', selected ? selected.uniqueName : '');
        },

        handleMajorEmployeeChange(arr, record, nameField, idField) {
            if (arr.length) {
                this.$set(record, nameField, arr.map(item => item.name).join(','));
                this.$set(record, idField, arr.map(item => item.userId).join(','));
            } else {
                this.$set(record, nameField, '');
                this.$set(record, idField, '');
            }
        },

        getMajorEmployeeValue(record, nameField, idField) {
            const names = (record[nameField] || '').split(',').filter(Boolean);
            const ids = (record[idField] || '').split(',').filter(Boolean);
            return names.map((name, idx) => ({name, userId: ids[idx] || ''}));
        },

        handleSubMajorEmployeeChange(arr, record, nameField, idField) {
            if (arr.length) {
                this.$set(record, nameField, arr.map(item => item.name).join(','));
                this.$set(record, idField, arr.map(item => item.userId).join(','));
            } else {
                this.$set(record, nameField, '');
                this.$set(record, idField, '');
            }
        },

        handleSubItemLeaderChange(arr, record) {
            if (arr.length) {
                this.$set(record, 'subLeaderName', arr.map(item => item.name).join(','));
                this.$set(record, 'subLeaderId', arr.map(item => item.userId).join(','));
            } else {
                this.$set(record, 'subLeaderName', '');
                this.$set(record, 'subLeaderId', '');
            }
        },

        getSubItemLeaderValue(record) {
            const names = (record.subLeaderName || '').split(',').filter(Boolean);
            const ids = (record.subLeaderId || '').split(',').filter(Boolean);
            return names.map((name, idx) => ({name, userId: ids[idx] || ''}));
        },

        _getSubMajorRoleFields(role) {
            const map = {
                designer: { nameField: 'designerNames', idField: 'designerIds' },
                reviewer: { nameField: 'reviewerNames', idField: 'reviewerIds' },
                auditor: { nameField: 'auditorNames', idField: 'auditorIds' },
                approver: { nameField: 'approverNames', idField: 'approverIds' },
            };
            return map[role] || map.designer;
        },
        getSubMajorOptions(record, role) {
            const majorDetail = (this.form.majorsDetail || []).find(m => m.majorValue === record.majorValue);
            if (!majorDetail) return [];
            const { nameField, idField } = this._getSubMajorRoleFields(role);
            const names = (majorDetail[nameField] || '').split(',').filter(Boolean);
            const ids = (majorDetail[idField] || '').split(',').filter(Boolean);
            return names.map((name, idx) => ({ label: name, value: ids[idx] || name }));
        },
        getSubMajorSelectedIds(record, role) {
            const { nameField, idField } = this._getSubMajorRoleFields(role);
            const ids = (record[idField] || '').split(',').filter(Boolean);
            if (ids.length) return ids;
            return (record[nameField] || '').split(',').filter(Boolean);
        },
        handleSubMajorSelectChange(vals, record, role) {
            const { nameField, idField } = this._getSubMajorRoleFields(role);
            const options = this.getSubMajorOptions(record, role);
            const selectedNames = vals.map(v => {
                const opt = options.find(o => o.value === v);
                return opt ? opt.label : v;
            });
            this.$set(record, nameField, selectedNames.join(','));
            this.$set(record, idField, vals.join(','));
        },
        syncSubMajorsFromMajorsDetail() {
            if (!this.form.majorsDetail || !this.form.subMajors) return;
            const roles = [
                { nameField: 'designerNames', idField: 'designerIds' },
                { nameField: 'reviewerNames', idField: 'reviewerIds' },
                { nameField: 'auditorNames', idField: 'auditorIds' },
                { nameField: 'approverNames', idField: 'approverIds' },
            ];
            this.form.subMajors.forEach(subMajor => {
                const majorDetail = this.form.majorsDetail.find(m => m.majorValue === subMajor.majorValue);
                if (majorDetail) {
                    roles.forEach(({ nameField, idField }) => {
                        this.$set(subMajor, nameField, majorDetail[nameField] || '');
                        this.$set(subMajor, idField, majorDetail[idField] || '');
                    });
                }
            });
        },

        addSubItem() {
            if (!this.form.subItems) {
                this.$set(this.form, 'subItems', []);
            }
            if (!this.form.subMajors) {
                this.$set(this.form, 'subMajors', []);
            }

            let planEndDateValue = '-';
            if (this.form.requireFinishDate) {
                if (moment.isMoment(this.form.requireFinishDate)) {
                    planEndDateValue = this.form.requireFinishDate.format('YYYY-MM-DD');
                } else {
                    const parsed = moment(this.form.requireFinishDate);
                    planEndDateValue = parsed.isValid() ? parsed.format('YYYY-MM-DD') : '-';
                }
            }

            const newItem = {
                _rowKey: Date.now() + Math.random(),
                subCode: '',
                subName: '',
                majors: [...(this.form.majorsArray || [])],
                subLeaderName: this.form.prjLeaderName || '',
                subLeaderId: this.form.prjLeaderId || '',
                planEndDate: planEndDateValue,
                sortNo: this.form.subItems.length + 1,
                remark: ''
            };
            this.form.subItems.push(newItem);

            const majors = this.form.majorsArray || [];
            majors.forEach(majorValue => {
                const majorItem = this.majorList.find(m => m.value === majorValue);
                if (majorItem) {
                    const majorDetail = (this.form.majorsDetail || []).find(m => m.majorValue === majorValue);
                    this.form.subMajors.push({
                        _rowKey: Date.now() + Math.random(),
                        subName: '',
                        subCode: '',
                        majorName: majorItem.name,
                        majorCode: majorItem.value || '',
                        majorValue: majorValue,
                        majorLeaderNames: majorDetail ? majorDetail.majorLeaderNames || '' : '',
                        majorLeaderIds: majorDetail ? majorDetail.majorLeaderIds || '' : '',
                        designerNames: majorDetail ? majorDetail.designerNames || '' : '',
                        designerIds: majorDetail ? majorDetail.designerIds || '' : '',
                        reviewerNames: majorDetail ? majorDetail.reviewerNames || '' : '',
                        reviewerIds: majorDetail ? majorDetail.reviewerIds || '' : '',
                        auditorNames: majorDetail ? majorDetail.auditorNames || '' : '',
                        auditorIds: majorDetail ? majorDetail.auditorIds || '' : '',
                        approverNames: majorDetail ? majorDetail.approverNames || '' : '',
                        approverIds: majorDetail ? majorDetail.approverIds || '' : '',
                        remark: ''
                    });
                }
            });
        },

        removeSubItem() {
            if (this.selectedSubItemKeys.length === 0) {
                this.$message.warning('请先选择要移除的子项');
                return;
            }
            this.$set(this.form, 'subItems', (this.form.subItems || []).filter(
                item => !this.selectedSubItemKeys.includes(item._rowKey)
            ));
            this.selectedSubItemKeys = [];
        },

        onSubItemSelectChange(keys) {
            this.selectedSubItemKeys = keys;
        },

        onHasSubItemChange(checked) {
            this.$set(this.form, 'hasSubItem', checked);
            if (!checked) {
                this.$set(this.form, 'subItems', []);
                this.$set(this.form, 'subMajors', []);
            }
        },

        updateSubMajorsFromSubItems() {
            if (!this.form.subItems || !this.form.subMajors) return;
            const newSubMajors = [];
            this.form.subItems.forEach(item => {
                const majors = item.majors || [];
                majors.forEach(majorValue => {
                    const majorItem = this.majorList.find(m => m.value === majorValue);
                    if (majorItem) {
                        const existing = this.form.subMajors.find(
                            sm => (sm._rowKey === item._rowKey || String(sm._rowKey).startsWith(String(item._rowKey) + '_')) && sm.majorValue === majorValue
                        );
                        if (existing) {
                            existing.subName = item.subName || '';
                            existing.subCode = item.subCode || '';
                            newSubMajors.push(existing);
                        } else {
                            const majorDetail = (this.form.majorsDetail || []).find(m => m.majorValue === majorValue);
                            newSubMajors.push({
                                _rowKey: item._rowKey + '_' + majorValue,
                                subName: item.subName || '',
                                subCode: item.subCode || '',
                                majorName: majorItem.name,
                                majorCode: majorItem.value || '',
                                majorValue: majorValue,
                                majorLeaderNames: majorDetail ? majorDetail.majorLeaderNames || '' : '',
                                majorLeaderIds: majorDetail ? majorDetail.majorLeaderIds || '' : '',
                                designerNames: majorDetail ? majorDetail.designerNames || '' : '',
                                designerIds: majorDetail ? majorDetail.designerIds || '' : '',
                                reviewerNames: majorDetail ? majorDetail.reviewerNames || '' : '',
                                reviewerIds: majorDetail ? majorDetail.reviewerIds || '' : '',
                                auditorNames: majorDetail ? majorDetail.auditorNames || '' : '',
                                auditorIds: majorDetail ? majorDetail.auditorIds || '' : '',
                                approverNames: majorDetail ? majorDetail.approverNames || '' : '',
                                approverIds: majorDetail ? majorDetail.approverIds || '' : '',
                                remark: ''
                            });
                        }
                    }
                });
            });
            this.$set(this.form, 'subMajors', newSubMajors);
        },

        validateForm() {
            const requiredFields = [
                { field: 'majorsArray', label: '参与专业', check: (v) => v && v.length > 0 },
                { field: 'prjLeaderName', label: '项目负责人' },
                { field: 'chiefEngineerName', label: '项目分管总工' },
                { field: 'deptLeaderName', label: '部门分管负责人' },
                { field: 'generalEngineerName', label: '总工' },
                { field: 'approverName', label: '批准人' },
                { field: 'designReviewDate', label: '设计评审时间' },
                { field: 'designInputDate', label: '设计输入下达时间' },
                { field: 'drawingDate', label: '出图时间' },
                { field: 'archiveDate', label: '归档时间' },
                { field: 'majorSubmitDate', label: '专业提资时间' },
                { field: 'specialEquipment', label: '所需特殊装备及设施' },
                { field: 'qualityTarget', label: '要达到的质量目标及要求' },
            ];

            for (const { field, label, check } of requiredFields) {
                const value = this.form[field];
                if (check) {
                    if (!check(value)) {
                        this.$message.error(`请${value ? '至少选择一个' : '选择'}${label}`);
                        return false;
                    }
                } else if (!value) {
                    this.$message.error(`请填写${label}`);
                    return false;
                }
            }

            if (this.form.manageLevel === 'company' && !this.form.companyLeaderName) {
                this.$message.error('请选择公司分管领导');
                return false;
            }

            // 专业人员信息：审定人整体必填，所有专业中只要有一个填写了审定人即校验通过
            const hasApprover = (this.form.majorsDetail || []).some(item =>
                String(item.approverIds || '').trim() || String(item.approverNames || '').trim()
            );
            if (!hasApprover) {
                this.$message.error('专业人员信息：请至少为一个专业选择审定人');
                return false;
            }

            if (this.form.hasSubItem) {
                const subItems = this.form.subItems || [];
                for (let i = 0; i < subItems.length; i++) {
                    const item = subItems[i];
                    const rowNum = i + 1;
                    if (!item.subCode || !item.subCode.trim()) {
                        this.$message.error(`子项信息第${rowNum}行：请填写子项编号`);
                        return false;
                    }
                    if (!item.subName || !item.subName.trim()) {
                        this.$message.error(`子项信息第${rowNum}行：请填写子项名称`);
                        return false;
                    }
                    if (!item.majors || item.majors.length === 0) {
                        this.$message.error(`子项信息第${rowNum}行：请选择参与专业`);
                        return false;
                    }
                    if (!item.subLeaderName || !item.subLeaderName.trim()) {
                        this.$message.error(`子项信息第${rowNum}行：请填写子项负责人`);
                        return false;
                    }
                }
            }

            if (!this.fileList || this.fileList.length === 0) {
                this.$message.error('请上传附件');
                return false;
            }

            return true;
        },

        submitReview() {
            if (!this.validateForm()) return;

            this.submitting = true;
            resubmitDesignPlan(this.buildSubmitParams())
                .then(() => {
                    this.$close(this.$route.path, "/approval/task");
                })
                .catch((e) => {
                    console.error("提交失败详情", e);
                    this.$message.error("提交失败");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },

        goBack() {
            this.$close(this.$route.path);
        },
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        handleFileClick(event, url, filename) {
            if (this.isPdfFile(filename)) {
                event.preventDefault();
                this.previewPdf(url, filename);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.wrapper {
  background-color: #f9f9f9;
  padding-top: 24px;
  padding-bottom: 8px;
}

.title {
  font-weight: bold;
  font-size: 17px;
  margin: 12px 0;
}

.center {
  margin-top: 80px;
  display: flex;
  justify-content: center;
}

.header-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: -30px;
}

.header-right-item {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100px;
}

.specVicePresident {
  text-align: center;
  margin: 15px 0;
}

.hintInit {
  margin: 10px 0;
  margin-left: 5%;
}

.hint {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  margin-top: 2px;
  padding-left: 8px;
}

.hintName {
  color: red;
  height: 25px;
  white-space: nowrap;
}

.hintTitle {
  color: #000c17;
}

.hintText {
  margin-top: -10px !important;
  height: 25px !important;
}

.table-scroll-wrapper {
  max-width: 90%;
  margin: 0 auto;
  overflow-x: auto;
}

.fixed-width-table {
  width: 95%;
  margin: 0 auto;
  background: #fff;
}
</style>
